import { observer } from 'mobx-react-lite'
import { ContainerHeader } from 'shared/ui'
import { useReviewsListContext, useReviewsPageContext } from 'pages/reviews/context'
import {
  GuideButton,
  NewReviewButton,
} from 'pages/reviews/pages/all/ui/ReviewsActions/ReviewsActions'
import styles from './styles.module.scss'

export const ReviewsListHeader = observer(() => {
  const {
    pageLayoutStore: { titleIconProps, handleToggleCollapse },
  } = useReviewsPageContext()
  const { isEmpty } = useReviewsListContext()
  const actions = [
    {
      iconButtonComponent: <GuideButton className={styles.helpGuideButton} />,
    },
    {
      iconButtonComponent: <NewReviewButton />,
    },
  ]

  if (isEmpty) return null

  return (
    <ContainerHeader
      title={'Reviews'}
      titleVariant={'heading-md'}
      titleIconProps={titleIconProps}
      titleIconAction={handleToggleCollapse}
      paddingLeft={20}
      paddingRight={20}
      actionsGap={8}
      actions={actions}
    />
  )
})
